import React from 'react';
import { useNavigate } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { PageTransition } from '../components/PageTransition';
import { useOrder } from '../context/OrderContext';
import { useLanguage } from '../context/LanguageContext';
import { CalendarDays, ChevronLeft } from 'lucide-react';
export const PickupDay = () => {
  const navigate = useNavigate();
  const {
    setPickupDate,
    pickupDate
  } = useOrder();
  const {
    t,
    dateLocale
  } = useLanguage();
  // Order cutoff: a pickup day must be ordered by 20:00 the day before.
  // If it's already 20:00 or later, the next day's slot is closed, so the
  // earliest selectable pickup shifts to the day after. (Enforced internally.)
  const today = new Date();
  const earliestOffset = today.getHours() >= 20 ? 2 : 1;
  const days = [addDays(today, earliestOffset), addDays(today, earliestOffset + 1), addDays(today, earliestOffset + 2)];
  const handleSelectDay = (date: Date) => {
    setPickupDate(date);
    navigate('/menu');
  };
  return <PageTransition className="p-6" data-id="element-173">
      <button onClick={() => navigate('/')} className="w-10 h-10 bg-white rounded-full shadow-soft flex items-center justify-center text-espresso mb-6 hover:bg-cream-dark transition-colors" data-id="element-174">
        <ChevronLeft size={20} data-id="element-175" />
      </button>

      <div className="mb-8" data-id="element-176">
        <div className="w-12 h-12 bg-terracotta/10 rounded-2xl flex items-center justify-center mb-4 text-terracotta" data-id="element-177">
          <CalendarDays size={24} data-id="element-178" />
        </div>
        <h1 className="text-3xl font-serif text-espresso mb-2" data-id="element-179">
          {t('pickup.heading')}
        </h1>
        <p className="text-espresso-light" data-id="element-180">{t('pickup.sub')}</p>
      </div>

      <div className="space-y-3" data-id="element-181">
        {days.map((date, idx) => {
        const isSelected = pickupDate && format(pickupDate, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd');
        const isTomorrow = idx === 0 && earliestOffset === 1;
        return <button key={date.toISOString()} onClick={() => handleSelectDay(date)} className={`w-full p-5 rounded-2xl border text-left transition-all active:scale-[0.98] flex items-center justify-between ${isSelected ? 'bg-terracotta text-white border-terracotta shadow-md' : 'bg-white border-border/50 text-espresso hover:border-terracotta/30 shadow-soft'}`} data-id="element-182">
              <div data-id="element-183">
                <div className="font-serif text-xl mb-1 capitalize" data-id="element-184">
                  {isTomorrow ? t('pickup.tomorrow') : format(date, 'EEEE', {
                locale: dateLocale
              })}
                </div>
                <div className={`text-sm capitalize ${isSelected ? 'text-white/80' : 'text-espresso-light'}`} data-id="element-185">
                  {format(date, 'MMMM d', {
                locale: dateLocale
              })}
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-white' : 'border-border'}`} data-id="element-186">
                {isSelected && <div className="w-2.5 h-2.5 bg-white rounded-full" data-id="element-187" />}
              </div>
            </button>;
      })}
      </div>
    </PageTransition>;
};